import { AbacoVuexModule, State } from "@abaco/web-common/src/app";

import { TrapItem } from "./models/TrapModel";

export default class TrapsVuexModule extends AbacoVuexModule {

    @State() farmerTraps!: TrapItem[];
    @State() curTrap!: TrapItem;

    @State({default: 0}) triggerZoomOverTrap!: number;
    @State({default: 0}) triggerTrapSelection!: number;

    @State({default: 0}) triggerStationsLoaded!: number;
    @State({default: 0}) triggerNearbyPlotSelection!: number;
    @State({default: 0}) triggerZoomOverNearbyPlotsStation!: number;
    @State({default: 0}) refreshCapturesChart!: number;
    @State({default: 1000}) filterNearbyPlotsDistance!: number;

    @State() coordinatesText!: string | null;

    @State({default: false}) loadingSensorHistoryData!: boolean ;
    @State({default: false}) loadingStations!: boolean ;

    @State({default: false}) editModal!: boolean;

    @State({default: []}) creationPoint!: number[]
}
